import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { watch, Ref } from "vue";
import { FinOneMarcaProductoAction } from "../../actions/marcaActions";

export function useMarcaProductoFindOne(id: Ref<string>) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["MarcaProductoFindOne", id],
    queryFn: () => FinOneMarcaProductoAction(id.value),
    enabled: !!id.value, // evita ejecutar si id está vacío
    staleTime: 60 * 1000, // 1 minuto
  });

  // Si cambia el ID, hacer prefetch
  watch(id, (newId) => {
    if (newId) {
      queryClient.prefetchQuery({
        queryKey: ["MarcaProductoFindOne", newId],
        queryFn: () => FinOneMarcaProductoAction(newId),
      });
    }
  });

  return {
    ...query, // => { data, isPending, isError, error, refetch, ... }
  };
}
